import naja from "naja";
import * as bootstrap from 'bootstrap';
import FormHandler from "./form-handler.js";

window.bootstrap = bootstrap;

const modules = {
};

function initFormModules(root = document) {
	FormHandler.init(root);
}


function bindModules(root = document) {
	root.querySelectorAll('[data-module]').forEach(el => {
		const moduleName = el.dataset.module;
		const module = modules[moduleName];
		if (module && typeof module.init === 'function') {
			module.init(el);
		}
	});

	initFormModules(root);
}

function initBindings() {
	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
	tooltipTriggerList.forEach(el => {
		bootstrap.Tooltip.getOrCreateInstance(el);
	});

	const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
	popoverTriggerList.forEach(el => {
		bootstrap.Popover.getOrCreateInstance(el);
	});

	//ToDo: Remove
	$(".datepicker").datepicker({
		dateFormat: 'd.m.yy',
		monthNames: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
		dayNames: ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
		dayNamesMin: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
		firstDay: 1,
	});
}

async function setupNajaHook() {
		naja.snippetHandler.addEventListener('afterUpdate', (event) => {
			const snippet = event.detail.snippet || {};
			if(snippet){
				bindModules(snippet);
			}
			initBindings();
		});
}


export default {
	async init() {
		// Počkej na DOM pokud není připravený
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => {
				this.initializeWithDOM();
			});
		} else {
			await this.initializeWithDOM();
		}
	},

	async initializeWithDOM() {
		bindModules();
		await setupNajaHook();
	}

};
